import React from 'react'
import Table from '../../components/common/Table'
import { MemberFeeAmountDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface MemberFeeAmountTableProps {
  data: MemberFeeAmountDTO[];
  handleEdit: (row: MemberFeeAmountDTO) => void;
  handleDelete: (row: MemberFeeAmountDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading?: boolean;
}

const MemberFeeAmountTable: React.FC<MemberFeeAmountTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading = false,
}) => {
  return (
    <Table
      columns={[
        {
          label: "Fee",
          key: "fee",
          format: (value: number) => `R ${value.toFixed(2)}`,
        },
        {
          label: "Join Fee",
          key: "joinFee",
          format: (value: number) => value ? `R ${value.toFixed(2)}` : '-',
        },
        {
          label: "Effective Date",
          key: "effectiveDate",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
        {
          label: "Added",
          key: "createdUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default MemberFeeAmountTable;
